export default "__VITE_ASSET__165769e8__"